export default __webpack_public_path__ + "static/fjZEONGD-cd706bd6ce0bde17368f0a146a7b6124.svg";